function getIdFromIdIri(idIri: string) {
  return parseInt(idIri.split('/')[2]);
}

export default getIdFromIdIri;
